import { render, staticRenderFns } from "./PetrolService.vue?vue&type=template&id=a2bac0d6&"
import script from "./PetrolService.vue?vue&type=script&lang=js&"
export * from "./PetrolService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports